import React, { Component, Fragment } from 'react'
import { LanguageConsumer, Translate } from '../../../../contexts/LanguageContext';
import { Loading, BreadCrumb, Card } from '../../../../components';
import { PaymentService } from '../../../../services/PaymentService';
import { DepositService } from '../../../../services/DepositService';

export class UnipaymentResult extends Component {

    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            error: false,
            errorMessage: '',
            depositInfo: null,
            invoiceInfo: null,
            lastDepositData: null
        }
    }

    componentDidMount() {
        // Get deposit information from localStorage
        const lastDeposit = localStorage.getItem("lastDeposit");

        if (!lastDeposit) {
            // No deposit data found, redirect to deposit page
            this.setState({
                loading: false,
                error: true,
                errorMessage: 'No deposit information found'
            });
            setTimeout(() => {
                this.props.history.push('/deposit');
            }, 3000);
            return;
        }

        try {
            const depositData = JSON.parse(lastDeposit);

            if (depositData.method !== "Unipayment") {
                // Wrong payment method
                this.setState({
                    loading: false,
                    error: true,
                    errorMessage: 'Invalid payment method'
                });
                setTimeout(() => {
                    this.props.history.push('/deposit');
                }, 3000);
                return;
            }

            this.setState({ lastDepositData: depositData.detail }, () => {
                this.fetchDepositAndInvoiceDetails();
            });

        } catch (e) {
            this.setState({
                loading: false,
                error: true,
                errorMessage: 'Failed to parse deposit information'
            });
        }
    }

    async fetchDepositAndInvoiceDetails() {
        const { lastDepositData } = this.state;

        if (!lastDepositData || !lastDepositData.transactionId || !lastDepositData.invoice) {
            this.setState({
                loading: false,
                error: true,
                errorMessage: 'Invalid deposit data structure'
            });
            return;
        }

        try {
            // Fetch both deposit details and invoice details in parallel
            const [invoiceResponse] = await Promise.all([
                // DepositService.Detail({ transactionId: lastDepositData.transactionId }),
                PaymentService.Deposit.Unipayment.getInvoice(lastDepositData.invoice.invoice_id || lastDepositData.invoice.invoiceId)
            ]);

            // if (!depositResponse || depositResponse.error) {
            //     this.setState({
            //         loading: false,
            //         error: true,
            //         errorMessage: depositResponse.message || 'Failed to fetch deposit details'
            //     });
            //     return;
            // }

            if (!invoiceResponse || invoiceResponse.error) {
                this.setState({
                    loading: false,
                    error: true,
                    errorMessage: invoiceResponse.message || 'Failed to fetch invoice details'
                });
                return;
            }

            this.setState({
                loading: false,
                // depositInfo: depositResponse.data || depositResponse,
                invoiceInfo: invoiceResponse.data || invoiceResponse,
                error: false
            });

            // Clear localStorage after successful fetch
            // localStorage.removeItem("lastDeposit");

        } catch (error) {
            this.setState({
                loading: false,
                error: true,
                errorMessage: 'Network error while fetching details'
            });
        }
    }

    navigateToHome() {
        this.props.history.push('/home');
    }

    getStatusBadge(status) {
        const statusMap = {
            'New': 'badge-info',
            'Paid': 'badge-success',
            'Confirmed': 'badge-success',
            'Complete': 'badge-success',
            'Expired': 'badge-danger',
            'Invalid': 'badge-danger',
            'Processing': 'badge-warning',
            'Pending': 'badge-warning'
        };
        return statusMap[status] || 'badge-secondary';
    }

    formatDate(dateString) {
        if (!dateString) return 'N/A';
        try {
            return new Date(dateString).toLocaleString();
        } catch (e) {
            return dateString;
        }
    }

    render() {
        const { loading, error, errorMessage, depositInfo, invoiceInfo } = this.state;

        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={loading} Title={Translate("Loading Deposit Details")} />
                        <BreadCrumb 
                            Title={Translate("Deposit Result")} 
                            Name={Translate("Unipayment Deposit")} 
                            SubTitle={Translate("Deposit")} 
                            SubUrl="/deposit" 
                        />

                        {error ? (
                            <Card 
                                Title={Translate("Error")} 
                                Description={Translate("Failed to load deposit information")}
                            >
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="alert alert-danger" role="alert">
                                            <h4 className="alert-heading">
                                                <i className="fas fa-exclamation-triangle"></i> {Translate("Error!")}
                                            </h4>
                                            <p className="mb-0">{Translate(errorMessage)}</p>
                                        </div>
                                        <div className="text-center mt-4">
                                            <button 
                                                type="button" 
                                                className="btn btn-lg btn-primary" 
                                                onClick={() => this.props.history.push('/deposit')}
                                            >
                                                <i className="fas fa-arrow-left"></i> {Translate("Back to Deposit")}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        ) : (
                            <Card 
                                Title={Translate("Deposit Request Successful")} 
                                Description={Translate("Your deposit request has been submitted successfully")}
                            >
                                <div className="row">
                                    <div className="col-md-12">
                                        {/* Success Alert */}
                                        <div className="alert alert-success" role="alert">
                                            <h4 className="alert-heading">
                                                <i className="far fa-check-circle"></i> {Translate("Success!")}
                                            </h4>
                                            <p className="mb-0">
                                                {Translate("Your deposit request has been received and is being processed. You will receive a confirmation once the transaction is complete.")}
                                            </p>
                                        </div>

                                        {/* Deposit Information */}
                                        {depositInfo && (
                                            <div className="card border-success mt-4">
                                                <div className="card-header bg-success text-white">
                                                    <h5 className="mb-0">
                                                        <i className="fas fa-file-invoice-dollar"></i> {Translate("Deposit Information")}
                                                    </h5>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="font-weight-bold text-muted">
                                                                    <i className="fas fa-hashtag"></i> {Translate("Transaction ID")}
                                                                </label>
                                                                <p className="form-control-static text-dark h5">
                                                                    {depositInfo.transactionId || depositInfo.id || 'N/A'}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="font-weight-bold text-muted">
                                                                    <i className="fas fa-calendar-alt"></i> {Translate("Date & Time")}
                                                                </label>
                                                                <p className="form-control-static text-dark h5">
                                                                    {this.formatDate(depositInfo.createdDate || depositInfo.date || depositInfo.created_at)}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="font-weight-bold text-muted">
                                                                    <i className="fas fa-user-circle"></i> {Translate("Account")}
                                                                </label>
                                                                <p className="form-control-static text-dark h5">
                                                                    {depositInfo.login || depositInfo.account || 'N/A'}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="font-weight-bold text-muted">
                                                                    <i className="fas fa-dollar-sign"></i> {Translate("Amount")}
                                                                </label>
                                                                <p className="form-control-static text-dark h5">
                                                                    {depositInfo.amount || '0'} {depositInfo.currency || 'USD'}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="font-weight-bold text-muted">
                                                                    <i className="fas fa-info-circle"></i> {Translate("Status")}
                                                                </label>
                                                                <p className="form-control-static">
                                                                    <span className={`badge ${this.getStatusBadge(depositInfo.status)} badge-pill h5 px-3 py-2`}>
                                                                        {Translate(depositInfo.status || 'Processing')}
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="font-weight-bold text-muted">
                                                                    <i className="fas fa-credit-card"></i> {Translate("Payment Method")}
                                                                </label>
                                                                <p className="form-control-static text-dark h5">
                                                                    Unipayment
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Invoice Information */}
                                        {invoiceInfo && (
                                            <div className="card border-info mt-4">
                                                <div className="card-header bg-info text-white">
                                                    <h5 className="mb-0">
                                                        <i className="fas fa-receipt"></i> {Translate("Invoice Information")}
                                                    </h5>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="font-weight-bold text-muted">
                                                                    <i className="fas fa-file-invoice"></i> {Translate("Invoice ID")}
                                                                </label>
                                                                <p className="form-control-static text-dark h5">
                                                                    {invoiceInfo.invoice_id || invoiceInfo.invoiceId || 'N/A'}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label className="font-weight-bold text-muted">
                                                                    <i className="fas fa-coins"></i> {Translate("Invoice Status")}
                                                                </label>
                                                                <p className="form-control-static">
                                                                    <span className={`badge ${this.getStatusBadge(invoiceInfo.status)} badge-pill h5 px-3 py-2`}>
                                                                        {Translate(invoiceInfo.status || 'New')}
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {invoiceInfo.pay_currency && (
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label className="font-weight-bold text-muted">
                                                                        <i className="fab fa-bitcoin"></i> {Translate("Payment Currency")}
                                                                    </label>
                                                                    <p className="form-control-static text-dark h5">
                                                                        {invoiceInfo.pay_currency}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label className="font-weight-bold text-muted">
                                                                        <i className="fas fa-money-bill-wave"></i> {Translate("Payment Amount")}
                                                                    </label>
                                                                    <p className="form-control-static text-dark h5">
                                                                        {invoiceInfo.pay_amount || '0'} {invoiceInfo.pay_currency || ''}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {invoiceInfo.expiration_time && (
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label className="font-weight-bold text-muted">
                                                                        <i className="far fa-clock"></i> {Translate("Expiration Time")}
                                                                    </label>
                                                                    <p className="form-control-static text-dark h5">
                                                                        {this.formatDate(invoiceInfo.expiration_time)}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            {/* {invoiceInfo.invoice_url && (
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label className="font-weight-bold text-muted">
                                                                            <i className="fas fa-link"></i> {Translate("Payment Link")}
                                                                        </label>
                                                                        <p className="form-control-static">
                                                                            <a 
                                                                                href={invoiceInfo.invoice_url} 
                                                                                target="_blank" 
                                                                                rel="noopener noreferrer"
                                                                                className="btn btn-sm btn-outline-primary"
                                                                            >
                                                                                <i className="fas fa-external-link-alt"></i> {Translate("Open Invoice")}
                                                                            </a>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            )} */}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        {/* Important Notice */}
                                        <div className="alert alert-info mt-4" role="alert">
                                            <h5 className="alert-heading">
                                                <i className="fas fa-info-circle"></i> {Translate("Important Information")}
                                            </h5>
                                            <ul className="mb-0 pl-3">
                                                <li>{Translate("Processing time may vary depending on the payment method and network confirmation.")}</li>
                                                <li>{Translate("You will receive a notification once your deposit is confirmed.")}</li>
                                                <li>{Translate("Please complete the payment before the invoice expires.")}</li>
                                                <li>{Translate("Keep your transaction ID for future reference.")}</li>
                                                <li>{Translate("If you have any questions, please contact our support team.")}</li>
                                            </ul>
                                        </div>

                                        {/* Action Buttons */}
                                        <div className="row mt-4">
                                            <div className="col-md-12 text-center">
                                                <button 
                                                    type="button" 
                                                    className="btn btn-lg btn-primary mr-3" 
                                                    onClick={() => this.navigateToHome()}
                                                >
                                                    <i className="fas fa-home"></i> {Translate("Go to Home")}
                                                </button>
                                                <button 
                                                    type="button" 
                                                    className="btn btn-lg btn-outline-secondary mr-3" 
                                                    onClick={() => this.props.history.push('/deposit')}
                                                >
                                                    <i className="fas fa-plus-circle"></i> {Translate("Make Another Deposit")}
                                                </button>
                                                {/* {invoiceInfo && invoiceInfo.invoice_url && (
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-lg btn-success" 
                                                        onClick={() => window.open(invoiceInfo.invoice_url, '_blank')}
                                                    >
                                                        <i className="fas fa-external-link-alt"></i> {Translate("View Invoice")}
                                                    </button>
                                                )} */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        )}
                    </Fragment>
                )}
            </LanguageConsumer>
        )
    }
}
